import {initProductSwiper} from "../swiper/swiper";
import GLightbox from 'glightbox';

const classPrefix = 'product-card';
const dataPrefix = 'data-product-card';

const $container = document.querySelector(`[${dataPrefix}]`);

if ($container) {
    productCard($container);
}

function productCard(container) {
    const descriptionText = container.querySelector(`[${dataPrefix}-description-text]`);
    const toggleButton = container.querySelector(`[${dataPrefix}-description-wrap]`);

    const imgClass  = `${classPrefix}__swiper-image`;
    const prevClass = `${classPrefix}__swiper-prev`;

    GLightbox({
        selector: '.glightbox',
        openEffect: 'fade',
        closeEffect: 'fade'
    });

    init();

    function init(){
        handleDescriptionWrap();
        initProductSlider();
    }

    function handleDescriptionWrap(){
        if (descriptionText && toggleButton) {
            const lineHeight = parseFloat(getComputedStyle(descriptionText).lineHeight);
            const collapsedLines = 4;
            const collapsedHeight = lineHeight * collapsedLines;
            const fullHeight = descriptionText.scrollHeight;

            descriptionText.style.maxHeight = `${collapsedHeight}px`;
            descriptionText.style.overflow = 'hidden';
            descriptionText.style.transition = 'max-height 0.5s ease';

            let isExpanded = false;
            toggleButton.addEventListener('click', () => {
                isExpanded = !isExpanded;
                if (isExpanded) {
                    descriptionText.style.maxHeight = `${fullHeight}px`;
                    toggleButton.textContent = 'Сховати';
                } else {
                    descriptionText.style.maxHeight = `${collapsedHeight}px`;
                    toggleButton.textContent = 'Читати далі...';
                }
            });
        }
    }
    function initProductSlider(){
        initProductSwiper(imgClass, prevClass);
    }
}
